import { ErrorNames, UserFriendlyError } from '@affine/graphql';
import { isBackendError } from '@docnboard/rest';
import { Store } from '@toeverything/infra';

import { type FetchService } from '../../cloud';

export class ShareReaderStore extends Store {
  constructor(private readonly fetchService: FetchService) {
    super();
  }

  async loadShare(workspaceId: string, docId: string) {
    try {
      const docResponse = await this.fetchService.fetch(
        `/api/workspaces/${workspaceId}/docs/${docId}`
      );

      const docBinary = await docResponse.arrayBuffer();

      return {
        doc: new Uint8Array(docBinary),
      };
    } catch (error) {
      if (
        error instanceof Error &&
        isBackendError(error) &&
        UserFriendlyError.fromAnyError(error).name === ErrorNames.ACCESS_DENIED
      ) {
        return null;
      }
      throw error;
    }
  }
}
